// Exports
export default {
	"wrapper": "wrapper_0NDq2",
	"title": "title_fG89q",
	"titleWrapper": "titleWrapper_wVLoa"
};
